import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import * as utils from '@utils'
import { API } from '@const'
import { Switch, Button, Grid, FormControlLabel, Checkbox, FormControl, FormLabel } from '@material-ui/core'
import { CheckCircleOutline, HighlightOff, VerticalAlignBottom, VerticalAlignTop, Search } from '@material-ui/icons'
import Table from '@tables/table'
import ConfirmMsgDialog from '@msg/confirm-msg-dialog'
import { TreeSelect } from 'antd'
import 'antd/dist/antd.css'
import { withStyles } from '@material-ui/styles'
import { green } from '@material-ui/core/colors';

const COMPONENT_GROUP = 'game_list'

class GamePage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'GamePage')
        }
    }

    actions = []
    columns = [
        {
            field: 'no',
            render: (rowData) => {
                return rowData['no'] ? rowData['no'] : ''
            },
        },
        {
            field: 'game_type',
            render: (rowData) => {
                return rowData['display_game_type_code_id']
            },
            searchable: true
        },
        {
            field: 'game_code',
        },
        {
            field: 'game_type_name',
            hidden: true,
            render: (rowData) => {
                return rowData['no'] ? this.t('GameType.' + rowData['display_game_type_code_id']) : '-'
            },
        },
        {
            field: 'name_chs',
        },
        {
            field: 'name_enu',
        },
        {
            field: 'name_vi',
            hidden: true,
        },
        {
            field: 'name_th',
            hidden: true,
        },
        {
            field: 'name_id',
            hidden: true,
        },
        {
            field: 'name_es',
            hidden: true,
        },
        {
            field: 'name_pt',
            hidden: true,
        },
        {
            field: 'support_lang',
            render: (rowData) => {
                if (rowData['support_lang']) {
                    return rowData['support_lang']
                    .split(',')
                    .map((elem) => this.t('Lang.' + elem))
                    .join(', ')
                } else {
                    return '-'
                }
            },
        },
        {
            field: 'support_device',
            render: (rowData) => {
                if (rowData['parent']) { return '-' }
                if (rowData['support_device'].length === 0) { return rowData['support_device'] }

                let translatedString = ''
                const supportDeviceArr = rowData['support_device'].split(',')
                for (const idx in supportDeviceArr) {
                    translatedString += this.t('Device.' + supportDeviceArr[idx]) + ', '
                }
                return translatedString.slice(0, -2)
            },
        },
        {
            field: 'is_active',
            type: 'icon',
            render: (rowData) => {
                const { classes } = this.props
                if (rowData['parent']) {
                    return rowData['is_register'] ? (
                        <CheckCircleOutline className={classes.checkCircle} />
                    ) : (
                        <HighlightOff className={classes.highlightOff} />
                    )
                } else {
                    return rowData['is_active'] ? (
                        <CheckCircleOutline className={classes.checkCircle} />
                    ) : (
                        <HighlightOff className={classes.highlightOff} />
                    )
                }
            },
        },
        {
            field: 'is_pf_active',
            type: 'action',
            export: false,
            render: (rowData) => {
                if (rowData['code_id']) {
                    return (
                        <div>
                            <GreenButton
                                className={this.props.classes.button}
                                style={{ minWidth: '72px' }}
                                onClick={() => {
                                    const game_code = rowData.game_code
                                    const params = {
                                        "enable": true,
                                        "targets": []
                                    }
                                    /** is_register true 的項目才可變更狀態 */
                                    rowData.platforms.forEach(subPf=>{
                                        params.targets.push({
                                            "platform_id": subPf.is_register ? subPf.id : '',
                                            game_code
                                        })
                                    })
                                    this.batchActiveGame(params)
                                }}
                                variant="contained"
                                color="primary"
                                disabled={!rowData['is_active'] || !utils.checkValid(COMPONENT_GROUP + '.active')}
                            >
                                {this.t('enableAll')}
                            </GreenButton>
                            <Button
                                className={this.props.classes.button}
                                style={{ minWidth: '72px' }}
                                onClick={() => {
                                    const game_code = rowData.game_code
                                    const params = {
                                        "enable": false,
                                        "targets": []
                                    }
                                    /** is_register true 的項目才可變更狀態 */
                                    rowData.platforms.forEach(subPf=>{
                                        params.targets.push({
                                            "platform_id": subPf.is_register ? subPf.id : '',
                                            game_code
                                        })
                                    })
                                    this.batchActiveGame(params)
                                }}
                                variant="contained"
                                color="primary"
                                disabled={!rowData['is_active'] || !utils.checkValid(COMPONENT_GROUP + '.active')}
                            >
                                {this.t('disableAll')}
                            </Button>
                        </div>
                    )
                } else {
                    return (<Switch
                        checked={rowData.is_active}
                        onChange={(event) => {
                            const params = {
                                "enable": event.target.checked,
                                "targets": []
                            }
                            params.targets.push({
                                "platform_id": rowData.id,
                                "game_code": rowData.parent
                            })
                            this.batchActiveGame(params)
                        }}
                        value="Status"
                        color="primary"
                        inputProps={{ 'aria-label': 'Status' }}
                        disabled={!rowData.is_register || !utils.checkValid(COMPONENT_GROUP + '.active')}
                    />)
                }
            }
        },
        {
            field: 'is_active',
            type: 'icon',
            title: utils.t('isPfActive', 'GamePage'),
            hidden: true,
            render: (rowData) => {
                return rowData['no'] ? '-' : rowData.is_active
            },
        }
    ]
    state = {
        gameAdminAuth: false,
        useGameAdmin: false,
        pfSubPfIDList: [],
        pfSubPfListDisabled: false,
        pfSubTree: [],
        selection: false,
        gameList: []
    }
    componentDidMount() {
        if (utils.checkValid(COMPONENT_GROUP + '.release')) {
            this.setState({
                gameAdminAuth: true
            })
        }
        if (utils.checkValid(COMPONENT_GROUP + '.active')) {
            this.setState({
                selection: true
            })
        }
        this.updateTableColumns()
        this.handlePfTreeData()
    }
    handleGetExclusiveTitle = () => {
        return this.state.useGameAdmin ? this.t('exclusiveGames') : this.t('exclusivePlatform')
    }
    updateTableColumns() {
        if (utils.checkValid(COMPONENT_GROUP + '.release')) {
            this.columns.push({
                field: 'release',
                type: 'action',
                export: false,
                render: (rowData) => {
                    return (
                        <Button
                            style={{ minWidth: '72px' }}
                            onClick={() => {
                                const params = {
                                    "enable": !rowData.is_active,
                                    "game_codes": [rowData.game_code]
                                }
                                this.batchReleaseGame(params)
                            }}
                            color="primary">
                            {!rowData.is_active ? <VerticalAlignTop /> : <VerticalAlignBottom />}
                            {!rowData.is_active ? this.t('release') : this.t('unrelease')}
                        </Button>
                    )
                },
            })
        }

        // 獨家遊戲開關
        if (utils.checkValid(COMPONENT_GROUP + '.release') || utils.checkValid(COMPONENT_GROUP + '.exclusive')) {
            this.columns.splice(14 , 0, {
                field: 'is_exclusive',
                type: 'action',
                title: this.handleGetExclusiveTitle(),
                render: (rowData) => {
                    if (this.state.useGameAdmin) {
                        return (<Switch
                            checked={rowData.is_exclusive}
                            onChange={(event) => {
                                const params = {
                                    is_exclusive: event.target.checked,
                                    game_code: [rowData.game_code]
                                }
                                this.batchActiveExclusiveGame(params)
                            }}
                            value="Status"
                            color="primary"
                            inputProps={{ 'aria-label': 'Status' }}
                            disabled={!rowData.is_active || !(utils.checkValid(COMPONENT_GROUP + '.active') || utils.checkValid(COMPONENT_GROUP + '.exclusive'))}
                        />)
                    } else {
                        if (rowData['code_id']) {
                            return (
                                <div>
                                    <GreenButton
                                        className={this.props.classes.button}
                                        style={{ minWidth: '72px' }}
                                        onClick={() => {
                                            const game_code = rowData.game_code
                                            const params = {
                                                is_exclusive: true,
                                                targets: []
                                            }
                                            /** is_active true 的項目才可變更狀態 */
                                            rowData.platforms.forEach(subPf=>{
                                                params.targets.push({
                                                    platform_id: subPf.is_active ? subPf.id : '',
                                                    game_code
                                                })
                                            })
                                            this.batchActiveExclusivePlatform(params)
                                        }}
                                        variant="contained"
                                        color="primary"
                                        disabled={!rowData.is_active || !rowData.is_exclusive || !(utils.checkValid(COMPONENT_GROUP + '.active') || utils.checkValid(COMPONENT_GROUP + '.exclusive'))}
                                    >
                                        {this.t('enableAll')}
                                    </GreenButton>
                                    <Button
                                        className={this.props.classes.button}
                                        style={{ minWidth: '72px' }}
                                        onClick={() => {
                                            const game_code = rowData.game_code
                                            const params = {
                                                is_exclusive: false,
                                                targets: []
                                            }
                                            /** is_active true 的項目才可變更狀態 */
                                            rowData.platforms.forEach(subPf=>{
                                                params.targets.push({
                                                    platform_id: subPf.is_active ? subPf.id : '',
                                                    game_code
                                                })
                                            })
                                            this.batchActiveExclusivePlatform(params)
                                        }}
                                        variant="contained"
                                        color="primary"
                                        disabled={!rowData.is_active || !rowData.is_exclusive || !(utils.checkValid(COMPONENT_GROUP + '.active') || utils.checkValid(COMPONENT_GROUP + '.exclusive'))}
                                    >
                                        {this.t('disableAll')}
                                    </Button>
                                </div>
                            )
                        } else {
                            return (<Switch
                                checked={rowData.is_exclusive}
                                onChange={(event) => {
                                    const params = {
                                        is_exclusive: event.target.checked,
                                        targets: []
                                    }
                                    params.targets.push({
                                        platform_id: rowData.id,
                                        game_code: rowData.parent
                                    })
                                    this.batchActiveExclusivePlatform(params)
                                }}
                                value="Status"
                                color="primary"
                                inputProps={{ 'aria-label': 'Status' }}
                                disabled={!rowData.parent_active || !rowData.parent_exclusive || !(utils.checkValid(COMPONENT_GROUP + '.active') || utils.checkValid(COMPONENT_GROUP + '.exclusive'))}
                            />)
                        }
                    }
                },
            })
        }
    }

    showHideColumn() {
        if (this.state.useGameAdmin) {
            this.table.ShowColumn('release')
            this.table.HideColumn('is_pf_active')
        } else {
            this.table.HideColumn('release')
            this.table.ShowColumn('is_pf_active')
        }
    }

    updateSelectAction = () => {
        utils.ClearArray(this.actions)
        if (this.state.useGameAdmin && utils.checkValid(COMPONENT_GROUP + '.release')) {
            this.actions.push({
                text: 'exclusiveGameEnable',
                icon: 'vertical_align_top_icon',
                onClick: (_evt, data) => {
                    const params = {
                        is_exclusive: true,
                        game_code: []
                    }
                    data.forEach(item => {
                        params.game_code.push(item.game_code)
                    })
                    this.batchActiveExclusiveGame(params)
                },
            })
            this.actions.push({
                text: 'exclusiveGameDisable',
                icon: 'vertical_align_bottom_icon',
                onClick: (_evt, data) => {
                    const params = {
                        is_exclusive: false,
                        game_code: []
                    }
                    data.forEach(item => {
                        params.game_code.push(item.game_code)
                    })
                    this.batchActiveExclusiveGame(params)
                },
            })
            this.actions.push({
                text: 'release',
                icon: 'vertical_align_top_icon',
                onClick: (_evt, data) => {
                    const params = {
                        "enable": true,
                        "game_codes": []
                    }
                    data.forEach(item => {
                        params.game_codes.push(item.game_code)
                    })
                    this.batchReleaseGame(params)
                },
            })
            this.actions.push({
                text: 'unrelease',
                icon: 'vertical_align_bottom_icon',
                onClick: (_evt, data) => {
                    const params = {
                        "enable": false,
                        "game_codes": []
                    }
                    data.forEach(item => {
                        params.game_codes.push(item.game_code)
                    })
                    this.batchReleaseGame(params)
                },
            })
        } else {
            if (utils.checkValid(COMPONENT_GROUP + '.release') || utils.checkValid(COMPONENT_GROUP + '.exclusive')) {
                this.actions.push({
                    text: 'exclusivePlatformEnable',
                    icon: 'check_circle',
                    onClick: (_evt, data) => {
                        const params = {
                            is_exclusive: true,
                            targets: []
                        }
                        data.forEach(item => {
                            /** 遊戲主項目不列入資料傳送(有code_id) */
                            if (item.code_id) {
                                return
                            }
                            /** parent_exclusive true 的項目才可變更狀態 */
                            params.targets.push({
                                platform_id: item.parent_exclusive ? item.id : '',
                                game_code: item.parent
                            })
                        })
                        this.batchActiveExclusivePlatform(params)
                    },
                })
                this.actions.push({
                    text: 'exclusivePlatformDisable',
                    icon: 'highlight_off',
                    onClick: (_evt, data) => {
                        const params = {
                            is_exclusive: false,
                            targets: []
                        }
                        data.forEach(item => {
                            /** 遊戲主項目不列入資料傳送(有code_id) */
                            if (item.code_id) {
                                return
                            }
                            /** parent_exclusive true 的項目才可變更狀態 */
                            params.targets.push({
                                platform_id: item.parent_exclusive ? item.id : '',
                                game_code: item.parent
                            })
                        })
                        this.batchActiveExclusivePlatform(params)
                    },
                })
            }
            this.actions.push({
                text: 'gameEnable',
                icon: 'check_circle',
                onClick: (_evt, data) => {
                    const params = {
                        "enable": true,
                        "targets": []
                    }
                    data.forEach(item => {
                        /** 遊戲主項目不列入資料傳送(有code_id) */
                        if (item.code_id) {
                            return
                        }
                        /** is_register true 的項目才可變更狀態 */
                        params.targets.push({
                            platform_id: item.is_register ? item.id : '',
                            game_code: item.parent
                        })
                    })
                    this.batchActiveGame(params)
                },
            })
            this.actions.push({
                text: 'gameDisable',
                icon: 'highlight_off',
                onClick: (_evt, data) => {
                    const params = {
                        "enable": false,
                        "targets": []
                    }
                    data.forEach(item => {
                        /** 遊戲主項目不列入資料傳送(有code_id) */
                        if (item.code_id) {
                            return
                        }
                        /** is_register true 的項目才可變更狀態 */
                        params.targets.push({
                            platform_id: item.is_register ? item.id : '',
                            game_code: item.parent
                        })
                    })
                    this.batchActiveGame(params)
                },
            })
        }
    }

    /** 遊戲上架/下架 */
    batchReleaseGame = (params) => {
        const confirmInfo = {
            title: params.enable ? this.t('gameOn') : this.t('gameOff'),
            msg: `${this.t('confirmSwitchMsg')}\n\n【${this.t('gameName')}】\n`
        }
        /** 產生確認框內容 */
        params.game_codes.forEach(item => {
            const { name_chs, name_enu } = this.state.gameList.find(game => {
                return item === game.game_code
            })
            confirmInfo.msg += `${name_chs} ${name_enu}\n`
        })
        this.confirmDialog.OpenDialog({
            type: confirmInfo.title,
            msg: confirmInfo.msg,
            confirm: () => {
                this.confirmDialog.SetConfirmBtnDisabled(true)
                utils.apiRequest(
                    'patch',
                    API.GAME_STATUS,
                    params,
                    async (_data) => {
                        this.confirmDialog.closeDialog()
                        this.queryData()
                    },
                    (_err) => {
                        this.confirmDialog.SetConfirmBtnDisabled(false)
                    },
                    false
                )
            },
        })
    }

    batchActiveConfirmMessage = ({targets = [], enable = false, type = 'game'}) => {
        const enableMessage = type === 'game' ? utils.t('gameEnable', 'common') : utils.t('exclusivePlatformEnable', 'common')
        const disableMessage = type === 'game' ? utils.t('gameDisable', 'common') : utils.t('exclusivePlatformDisable', 'common')
        const confirmInfo = {
            title: enable ? enableMessage : disableMessage,
            msg: `${this.t('confirmSwitchMsg')}\n\n`
        }
        const changeList = {}
        targets.forEach(item => {
            /** 遊戲代碼 */
            const game_code = item.game_code
            /** 遊戲清單項目新增 */
            if (!changeList[game_code]) {
                const { name_chs, name_enu } = this.state.gameList.find(game => {
                    return game_code === game.game_code
                })
                changeList[game_code] = {
                    nameChs: name_chs,
                    nameEnu: name_enu,
                    pfList: {}
                }
            }
            /** 有 platform_id 才需列入變更狀態 */
            if (item.platform_id) {
                /** 站台 */
                const platform = item.platform_id.split('_')[0]
                /** 平台名稱 */
                const subPlatformName = this.handleTransferPlatName(item.platform_id)
                /** 站台清單項目新增 */
                if (!changeList[game_code].pfList[platform]) {
                    changeList[game_code].pfList[platform] = {
                        pfName: this.t('Platform.' + platform),
                        subPf: []
                    }
                }
                changeList[game_code].pfList[platform].subPf.push(subPlatformName)
            }

        })
        /** 產生確認框內容 */
        Object.values(changeList).forEach((gameInfo)=>{
            confirmInfo.msg += `【${this.t('gameName')}】\n`
            confirmInfo.msg += `${gameInfo.nameChs} ${gameInfo.nameEnu}\n\n`
            confirmInfo.msg += `【${this.t('paltformList')}】\n`
            Object.keys(gameInfo.pfList).length && Object.values(gameInfo.pfList).forEach(pf=>{
                confirmInfo.msg += `${pf.pfName}\n`
                pf.subPf.forEach(sfp=> {
                    confirmInfo.msg += ` - ${sfp}\n`
                })
            })
            confirmInfo.msg += '\n'
        })

        return confirmInfo
    }

    /** 遊戲啟用/停用 */
    batchActiveGame = (params) => {
        const confirmInfo = this.batchActiveConfirmMessage({
            targets: params.targets,
            enable: params.enable,
            type: 'game'
        })
        /** 過濾可變更狀態的平台, 原params因彈窗內容顯示需求有加入不可操作的遊戲項目 */
        const nextParams = {
            enable: params.enable,
            targets: params.targets.filter(item => item.platform_id)
        }
        this.confirmDialog.OpenDialog({
            type: confirmInfo.title,
            msg: confirmInfo.msg,
            confirm: (_params) => {
                this.confirmDialog.SetConfirmBtnDisabled(true)
                utils.apiRequest(
                    'patch',
                    API.GAME_PLATFORMS_STATUS,
                    nextParams,
                    (_data) => {
                        this.confirmDialog.closeDialog()
                        this.queryData()
                    },
                    () => {
                        this.confirmDialog.SetConfirmBtnDisabled(false)
                    },
                    false
                )
            },
        })
    }

    /** 獨家開關啟用/停用 */
    batchActiveExclusiveGame = (params) => {
        const confirmInfo = {
            title: params.is_exclusive ? this.t('exclusiveGameEnable') : this.t('exclusiveGameDisable'),
            msg: `${this.t('confirmSwitchMsg')}\n\n【${this.t('gameName')}】\n`
        }
        /** 產生確認框內容 */
        params.game_code.forEach(item => {
            const { name_chs, name_enu } = this.state.gameList.find(game => {
                return item === game.game_code
            })
            confirmInfo.msg += `${name_chs} ${name_enu}\n`
        })
        this.confirmDialog.OpenDialog({
            type: confirmInfo.title,
            msg: confirmInfo.msg,
            confirm: () => {
                this.confirmDialog.SetConfirmBtnDisabled(true)
                utils.apiRequest(
                    'post',
                    API.EXCLUSIVE_GAME,
                    params,
                    async (_data) => {
                        this.confirmDialog.closeDialog()
                        this.queryData()
                    },
                    (_err) => {
                        this.confirmDialog.SetConfirmBtnDisabled(false)
                    },
                    false
                )
            },
        })
    }

    /** 獨家平台啟用/停用 */
    batchActiveExclusivePlatform = (params) => {
        const confirmInfo = this.batchActiveConfirmMessage({
            targets: params.targets,
            enable: params.is_exclusive,
            type: 'exclusive_game'
        })

        const processedData = params.targets.reduce((accumulator, currentItem) => {
            // 檢查 accumulator 中是否已經有這個 game_code 的物件
            const existingItem = accumulator.find(item => item.game_code === currentItem.game_code);
        
            if (existingItem) {
                // 如果找到，將當前的 platform_id 加到現有的 platform_id 陣列中
                existingItem.platform_list.push(currentItem.platform_id);
            } else {
                // 如果沒有找到，創建一個新的物件並推入 accumulator
                accumulator.push({
                    game_code: currentItem.game_code,
                    platform_list: [currentItem.platform_id],
                    is_exclusive: params.is_exclusive
                });
            }
        
            return accumulator;
        }, []);
        
        const postData = {
            exclusive: processedData
        }
        this.confirmDialog.OpenDialog({
            type: confirmInfo.title,
            msg: confirmInfo.msg,
            confirm: (_params) => {
                this.confirmDialog.SetConfirmBtnDisabled(true)
                utils.apiRequest(
                    'post',
                    API.EXCLUSIVE_PLATFORM,
                    postData,
                    (_data) => {
                        this.confirmDialog.closeDialog()
                        this.queryData()
                    },
                    () => {
                        this.confirmDialog.SetConfirmBtnDisabled(false)
                    },
                    false
                )
            },
        })
    }

    handlePfTreeData = () => {
        const PfTree = utils.generatePfTreeData()
        /** 預設全選 - 取得所有平台id */
        
        const pfSubPfIDList = PfTree.reduce((result, item) => {
            item.children.forEach((child) => {
                result.push(child.value)
            })
            return result
        }, [])

        this.setState({
            pfSubTree: [{
                title: this.t('treeDataAll'),
                key: 'all',
                value: 'all',
                children: PfTree
            }],
            pfSubPfIDList
        })
    }

    queryData() {
        this.table.SetData([])
        /** 是否使用遊戲管理者 */
        const isUseAdmin = this.state.useGameAdmin
        if (!isUseAdmin && this.state.pfSubPfIDList.length === 0) {
            utils.addToast(this.t('pfValidError'), 'error')
            return
        }
        this.table.SetLoading(true)
        this.showHideColumn()
        /** 產生多選時的table header操作列表 */
        utils.checkValid(COMPONENT_GROUP + '.active') && this.updateSelectAction()

        /** 遊戲管理者不輸出啟用狀態 */
        const activeItemIndex = this.table.state.columns.findIndex(item => item.field === 'is_active' && !item.hidden);
        if (activeItemIndex !== -1) {
            this.table.state.columns[activeItemIndex]['export'] = !isUseAdmin
        }

        /** 獨家欄位標題根據遊戲管理者變更 */
        const exclusiveItemIndex = this.table.state.columns.findIndex(item => item.field === 'is_exclusive');
        if (exclusiveItemIndex !== -1) {
            this.table.state.columns[exclusiveItemIndex]['title'] = this.handleGetExclusiveTitle()
        }
    
        /** 使用遊戲管理者狀態不需攜帶平台id */
        const platforms = isUseAdmin ? []: this.state.pfSubPfIDList 
        const apiUrl = isUseAdmin ? API.GAME_LIST : API.GAME_PLATFORMS_LIST
        const apiMethods = isUseAdmin ? 'get' : 'post'
        utils.apiRequest(
            apiMethods,
            apiUrl,
            {
                platforms,
            },
            async (data) => {
                /** 儲存原始遊戲清單 */
                this.setState({
                    gameList: data
                })
                /** 遊戲清單加入流水號 */
                data.forEach((item, index)=> {
                    item['no'] = index + 1
                })
                const tableForm = await this.handleDataForm(data, isUseAdmin)
                this.table.SetData(tableForm)
            },
            (_err) => {
                this.table.SetData([])
            },
            true
        )
    }
    /** 取得平台名稱 */
    handleTransferPlatName(pfSubId) {
        const curr = pfSubId.split('_')[0]
        return this.state.pfSubTree[0].children.find(currency => {
            return currency.key === curr
        })?.children.find(plat => {
            return plat.value === pfSubId
        })['title']
    }
    /** 轉換資料表格式 */
    async handleDataForm(data, admin) {
        const isGameAdmin = admin || false
        try {
            const list = []
            data.forEach(game => {
                const { is_active, game_code, is_exclusive } = game
                const name_chs = utils.t('GameName.' + game_code, '', { lng: 'zh' })
                const name_enu = utils.t('GameName.' + game_code, '', { lng: 'en' })
                const name_vi = utils.t('GameName.' + game_code, '', { lng: 'vi' })
                const name_th = utils.t('GameName.' + game_code, '', { lng: 'th' })
                const name_id = utils.t('GameName.' + game_code, '', { lng: 'id' })
                const name_es = utils.t('GameName.' + game_code, '', { lng: 'es' })
                const name_pt = utils.t('GameName.' + game_code, '', { lng: 'pt' })
                list.push({
                    ...game,
                    id: game_code,
                    game_type: game.display_game_type_code_id,
                    name_chs,
                    name_enu,
                    name_vi,
                    name_th,
                    name_id,
                    name_es,
                    name_pt
                })
                /** 非使用遊戲管理者: 產出樹狀結構 */
                !isGameAdmin && game.platforms.forEach(child => {
                    const platGame = {
                        ...child,
                        game_code,
                        parent: game_code,
                        parent_exclusive: is_exclusive,
                        parent_active: is_active,
                        display_game_type_code_id: `${this.t('Platform.' + child.id.split('_')[0])} - ${this.handleTransferPlatName(child.id)} (${child.id})`,
                        name_chs,
                        name_enu,
                        name_vi,
                        name_th,
                        name_id,
                        name_es,
                        name_pt
                    }
                    /** 遊戲下架狀態,下層平台皆顯示關閉 */
                    if (!is_active) {
                        platGame.is_active = is_active
                        platGame.is_register = is_active
                    }
                    list.push(platGame)
                })
            })
            return list
        } catch (error) {
            console.log(error)
            return []
        }
    }

    render() {
        return (
            <Grid container spacing={2}>
                <FormControl
                    className={this.props.classes.formControl}
                    disabled={this.state.pfSubPfListDisabled}>
                    <FormLabel className={this.props.classes.shrink}>{this.t('pfSubPf')}</FormLabel>
                    <TreeSelect
                        className={this.props.classes.treeSelect}
                        treeData={this.state.pfSubTree}
                        value={this.state.pfSubPfIDList}
                        onChange={(value) => {
                            this.setState({
                                pfSubPfIDList: value,
                            })
                        }}
                        disabled={this.state.pfSubPfListDisabled}
                        maxTagCount={1}
                        treeCheckable={true}
                        showSearch={true}
                        listHeight={64}
                        showCheckedStrategy={TreeSelect.SHOW_CHILD}
                        searchPlaceholder={this.t('pleaseSelect')}
                        dropdownStyle={{ zIndex: 3000 }}
                    />
                </FormControl>
                <Grid item xs={1} className={this.props.classes.alignCenter}>
                    <Button
                        variant="contained"
                        color="primary"
                        className={this.props.classes.button}
                        onClick={() => {
                            this.queryData()
                        }}
                        disabled={this.state.useGameAdmin}
                    >
                        <Search className={this.props.classes.rightIcon} />
                        {this.t('search')}
                    </Button>
                </Grid>
                {this.state.gameAdminAuth && <Grid item className={this.props.classes.alignCenter}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.state.useGameAdmin}
                                onChange={(event) => {
                                    const value = event.target.checked
                                    this.setState({
                                        useGameAdmin: value,
                                        pfSubPfListDisabled: value
                                    }, () => {
                                        value ? this.queryData() : this.table.SetData([])
                                    })
                                }}
                                name="checked"
                                color="primary"
                            />
                        }
                        label={this.t('Platform.gameManager')}
                        className={this.props.classes.labelMarginClear}
                    />
                </Grid>}
                <Grid item xs={12}>
                    <Table
                        ownerName="GamePage"
                        columns={this.columns}
                        options={{
                            selection: this.state.selection,
                            // 非遊戲管理者狀態 => 遊戲尚未上架或該平台尚未註冊該遊戲時不可勾選
                            selectionProps: rowData => ({
                                disabled: (rowData['no'] && !rowData['is_active'] && !this.state.useGameAdmin) || (!rowData['no'] && !rowData['is_register'])
                            }),
                            exportButton: true,
                        }}
                        actions={this.actions}
                        rowStyle={(rowData) => ({
                            opacity: rowData['is_register'] === false ? 0.6 : 1,
                            cursor: rowData['is_register'] === false ? 'not-allowed' : 'default'
                        })}
                        onRef={(ref) => (this.table = ref)}
                        parentChildData={(row, rows) => rows.find((a) => a.id === row.parent)}
                    />
                    <ConfirmMsgDialog onRef={(ref) => (this.confirmDialog = ref)} />
                </Grid>
            </Grid>
        )
    }
}

const styles = (theme) => {
    return {
        checkCircle: {
            color: '#36B37E',
        },
        highlightOff: {
            color: '#FF5630',
        },
        alignCenter: {
            display: 'inline-flex',
            alignItems: 'center',
        },
        button: {
            margin: theme.spacing(1),
        },
        rightIcon: {
            marginRight: theme.spacing(1),
        },
        labelMarginClear: {
            margin: 0,
        },
        formControl: {
            margin: theme.spacing(1)
        },
        treeSelect: {
            width: '240px',
        },
        shrink: {
            transform: 'translate(0, 1.5px) scale(0.75)',
            transformOrigin: 'top left',
        },
    }
}
const GreenButton = withStyles(() => ({
    root: {
      color: '#ffffff',
      backgroundColor: green[500],
      '&:hover': {
        backgroundColor: green[700],
      },
    },
}))(Button);

GamePage.propTypes = {
    classes: PropTypes.object.isRequired,
    auth: PropTypes.object,
}

export default hoc(styles)(GamePage)
